<script lang="ts">
    import { createEventDispatcher } from 'svelte'

    export let value: number = null
    export let disabled = false
    export let required = false
    export let autocomplete: string = null
    export let placeholder: string = ''
    export let labeled = false
    export let htmlInput = null

    const dispatch = createEventDispatcher()

    $: if (value === ('' as any)) {
        value = null
    }

    function onKeyup(ev) {
        dispatch('keyup', ev)
    }
    function onChange(ev) {
        dispatch('change', ev)
    }
    function onFocus(ev) {
        dispatch('focus', ev)
    }
    function onBlur(ev) {
        dispatch('blur', ev)
    }
</script>

<input
    {autocomplete}
    {required}
    {placeholder}
    bind:this={htmlInput}
    type="number"
    class="zinput_input zinput_input_labeled-{labeled}"
    bind:value
    {disabled}
    on:keyup={onKeyup}
    on:change={onChange}
    on:focus={onFocus}
    on:blur={onBlur}
/>
